module.exports = __webpack_public_path__ + "static/media/compartir.74ecdd0d.svg";